class TryInStore {
	constructor() {
		let cache = {};

		let initFunc = () => {
			initCache();
			registerEvents();
			observePopups();
		};

		let initCache = () => {
			cache.btnsSidebar = document.querySelectorAll("a.storepoint-website-button");
			cache.containerForm = document.querySelector(".form-try-in-store");
			cache.form = document.querySelector(".form-try-in-store form");
			cache.inputNameDealer = document.querySelector("input[name='name-dealer']");
			cache.inputAddressDealer = document.querySelector("input[name='address-dealer']");
			cache.inputDealer = document.querySelector("input[name='email-dealer']");
			cache.inputBikeName = document.querySelector("input[name='name-bike']");
			cache.mapContainer = document.body;
			cache.unselectedCard = document.querySelector(".dealer-card.unselected");
			cache.selectedCard = document.querySelector(".dealer-card.selected");
			cache.selectedCardTitle = cache.selectedCard.querySelector(
				".dealer-card-title"
			);
			cache.selectedCardAddress = cache.selectedCard.querySelector(
				".dealer-card-address"
			);
			cache.bikeName = document.querySelector(".product_title");
			cache.nameSpan = document.querySelector(
				".popup-try-in-store .module-12-dealer-locator span.name"
			);
		};

		let registerEvents = () => {
			// Capture phase: intercept the click before Storepoint's own
			// handlers on the sidebar row (.storepoint-location[role=button])
			// can stopPropagation, otherwise the event never bubbles to body
			// and the link follows its external href.
			cache.mapContainer.addEventListener(
				"click",
				(e) => {
					const button = e.target.closest("a.storepoint-website-button");
					if (button) {
						e.preventDefault();
						e.stopPropagation();
						handleDealerClick(button);
					}

					if (cache.bikeName) {
						cache.nameSpan.textContent = cache.bikeName.textContent.trim();
						if (cache.inputBikeName) {
							cache.inputBikeName.value = cache.bikeName.textContent.trim();
						}
					}
				},
				true
			);

		};

		let observePopups = () => {
			const observer = new MutationObserver(() => {
				initCache();
			});

			observer.observe(document.body, { childList: true, subtree: true });
		};

		let handleDealerClick = (button) => {
			const popup = button.closest(".storepoint-location-info");
			if (popup) {
				const titleElement = popup.querySelector(".storepoint-name");
				const emailElement = popup.querySelector("a.storepoint-email-link");
				const addressElement = popup.querySelector(".storepoint-address");
				const email = emailElement ? emailElement.textContent.trim() : null;
				const name = titleElement ? titleElement.textContent.trim() : null;
				const address = addressElement
					? addressElement.textContent.replace(/\s+/g, " ").trim()
					: null;

				if (name && cache.inputNameDealer) {
					cache.inputNameDealer.value = name;
				}

				if (address && cache.inputAddressDealer) {
					cache.inputAddressDealer.value = address;
				}

				if (email && cache.inputDealer) {
					cache.inputDealer.value = email;
				} else if (!email) {
					console.warn("Aucun email trouvé dans cette card.");
				}

				if (cache.selectedCardTitle && name) {
					cache.selectedCardTitle.textContent = name;
				}
				if (cache.selectedCardAddress && address) {
					cache.selectedCardAddress.textContent = address;
				}

				if (cache.selectedCard) {
					cache.selectedCard.classList.add("show");
				}

				if (cache.unselectedCard) {
					cache.unselectedCard.classList.remove("show");
				}

				// Scroll en dernier : l'affichage des cartes (show/hide) vient de
				// modifier la hauteur du formulaire. requestAnimationFrame laisse le
				// navigateur recalculer le layout avant de scroller, sinon le scroll
				// smooth part sur une position obsolète et n'aboutit pas (« parfois »).
				if (cache.containerForm) {
					requestAnimationFrame(() => {
						cache.containerForm.scrollIntoView({
							behavior: "smooth",
							block: "start",
						});
					});
				}
			}
		};

		initFunc();
	}
}

export { TryInStore };
